module.exports = __webpack_public_path__ + "static/media/stewart.48abec8a.jpeg";